import {Button} from "@/components/ui/button.tsx";

/**
 * Error composant
 * Le composant est rendu en utilisant le ErrorBoundary une fois une erreur détectée
 */
export function Error() {
    return <div className="flex-col gap-4 flex items-center justify-center w-full h-[100vh]">
        <p className="text-8xl font-bold">Oops !</p>
        <p className="text-2xl text-center mt-3">Une erreur s'est produite. Essayez de recharger la page. <br/>Si le problème persiste contactez l'administrateur</p>
        <Button size="lg" className="cursor-pointer text-[17px] mt-5" onClick={() => location.reload()}>Recharger</Button>
    </div>
}